import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'era-page-unauthorized',
  templateUrl: './page-unauthorized.component.html',
  styleUrls: ['./page-unauthorized.component.scss'],
})
export class PageUnauthorizedComponent {
  @HostBinding('class') hostClass = 'd-flex w-100';
}
